module.exports = __webpack_public_path__ + "assets/img/macIcon.fbe9929e.svg";